(() => {
  if (window.nlImageViewerReady) return;
  window.nlImageViewerReady = true;
  let dialog, image, previousOverflow;
  function setup() {
    dialog = document.createElement('dialog');
    dialog.className = 'nl-image-viewer';
    dialog.setAttribute('aria-label', 'Product image');
    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'nl-image-viewer__close';
    close.setAttribute('aria-label', 'Close image');
    close.textContent = '×';
    image = document.createElement('img');
    dialog.append(close, image);
    document.body.append(dialog);
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', e => { if (e.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => {
      document.documentElement.style.overflow = previousOverflow;
      image.removeAttribute('src');
    });
  }
  document.addEventListener('click', e => {
    if (!(e.target instanceof Element)) return;
    const gallery = e.target.closest('.product-gallery-wrapper, product-gallery, media-gallery');
    if (!gallery || e.target.closest('.product-gallery__navigation, [data-swiper-navigation], .media-gallery__thumbnails, button:not(.product-gallery--expand):not(.media__lightbox-button), video, model-viewer')) return;
    const trigger = e.target.closest('[data-photoswipe-trigger-for], .swiper-slide__inner, .media-gallery__slide, a');
    const img = e.target.closest('img') || trigger?.querySelector('img');
    if (!img || !img.closest('.product-gallery__viewer, .media-gallery__main, [data-photoswipe-trigger-for]')) return;
    const source = img.closest('[data-photoswipe-src]') || trigger?.querySelector('[data-photoswipe-src]');
    const src = source?.getAttribute('data-photoswipe-src') || img.currentSrc || img.src;
    if (!src) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (!dialog) setup();
    if (dialog.open) return;
    image.src = src;
    image.alt = img.alt || '';
    previousOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    dialog.showModal();
  }, true);
})();